export interface LogisticModeOption {
  value: string;
  label: string;
  description: string;
}

export const PLATFORM_NAME = 'MercadoLibreParcel';

export const AUTO_CREATE_LOGISTIC_MODES_OPTIONS: LogisticModeOption[] = [
  {
    value: 'me1',
    label: 'Mercado Envíos 1 (Flete Dinámico)',
    description: 'Envíos donde el vendedor gestiona su propia logística o flete acordado.',
  },
  {
    value: 'custom',
    label: 'Personalizado (Custom)',
    description: 'Envíos acordados con el comprador o logística propia del vendedor.',
  },
  {
    value: 'not_specified',
    label: 'No especificado / A convenir',
    description: 'Publicaciones donde el comprador acuerda el envío directamente con el vendedor.',
  },
];
